export default "__VITE_ASSET__DkMo7OBE__"